<script>
import { Bar } from 'vue-chartjs'
export default {
  name: 'TopProductsChart',
  props: ['topProducts'],
  extends: Bar,
  // props: ['data', 'options'],
  data () {
    return {
      data: {
        labels: this.topProducts.productNames,
        datasets: [{
          label: 'Downloads',
          barPercentage: 0.70,
          backgroundColor: '#c5263b',
          borderWidth: 0,
          data: this.topProducts.downloads
        } ]
      },
      options: {
        legend: {
          display: false
        },
        scaleShowVerticalLines: false,
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [{
            display: true,
            gridLines: false,
            ticks: {
              display: true,
              fontSize: 13,
              padding: 15
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Value'
            },
            gridLines: {
              drawBorder: false,
              offsetGridLines: false,
              drawTicks: false,
              borderDash: [3, 4],
              zeroLineWidth: 1,
              zeroLineBorderDash: [3, 4]
            },
            ticks: {
              display: true,
              beginAtZero: true,
              fontSize: 13,
              padding: 10
            }
          }]
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.data, this.options)
  },
  methods: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TopProductsChart.vue